export default "<p>{{rows}}</p>\n";